<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-管理奖设置-管理奖设置
  -->
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">资金池设置</div>
      <el-form-item label="订单入池比例" prop="name">
        <el-input v-model="form.ratioOfOrdersInThePool" placeholder="请输入订单入池比例" class="max-w460">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

      <div class="common-form">省仓设置</div>
      <el-form-item label="省仓升级条件" prop="name">
        推荐
        <el-input v-model="form.salesDirector.downAgentNum" placeholder="请输入加盟店人数" class="max-w160">
          <template slot="append">个</template>
        </el-input>
        加盟店，团队推荐
        <el-input v-model="form.salesDirector.groupDownAgentNum" placeholder="请输入加盟店人数" class="max-w160">
          <template slot="append">个</template>
        </el-input>
        加盟店
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import _ from 'lodash'
  import UserApi from '@/api/user.js'
  export default {
    data() {
      return {
        form: {
          ratioOfOrdersInThePool: '',
          salesDirector: {
            downAgentNum: '',
            groupDownAgentNum: '',
            teamPerformance: '',
            groupPerformance: '',
          },
        },
        loading: false,
        gradeList: [],
      };
    },
    created() {
      /*获取等级*/
      // this.getGradeList()
      /*获取数据*/
      this.getSetting();
    },
    methods: {
      /*获取数据*/
      getSetting() {
        let self = this
        UserApi.getFundsPool({}, true).then(data => {
          self.form = _.merge(self.form, data.data.form)
          self.gradeList = data.data.gradeList
        }).catch(error => {
          console.log(error)
        })
      },
      /*获取等级*/
      getGradeList() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        // UserApi.gradeAllList(Params, true)
        //     .then(data => {
        //       console.log("等级列表:", data)
        //       self.gradeList = _.merge(self.gradeList, data.data)
        //     })
        //     .catch(error => {
        //       console.log(error)
        //     });
      },
      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            UserApi.setFundsPool(form, true).then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message.success(data.msg)
              } else {
                self.loading = false;
              }
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/fundpool/Setting.vue